import React, { useContext, useEffect } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import useFormJson from "../../../../../../json/useFormJson";
import { LabelProps } from "../../../../../../utils/types";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Junction } from "./queries/types";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { useLazyQuery } from "@apollo/client";
import { GetJunctionNode } from "./queries/queries";
import { AppContext } from "../../../../../../context/context";

import { Label } from "../../../../../../stories/Label/Label";
import { EMPTY_STRING } from "../../../../../../utils/constants";
import Input from "../../../../../../stories/Input/Input";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg"
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const ParticuarJunctionDetails = ({ setModalFlag }: Props) => {
  const { JunctionsFormLabels } = useFormJson();
  const { state } = useContext(AppContext);
  
  const [GetJunctionByNode, { data: junctionData }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(GetJunctionNode);
  useEffect(() => {
    const fetchData = async () => {
      try {
       
        if (state.junctionID) {
          GetJunctionByNode({
            variables: {
              id: state.junctionID,
            
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [state.companyId, GetJunctionByNode]);

  return (
    <>
      <div className="view-junctions">
        <div className="view-junctions__title">
<Title>{ junctionData ? junctionData.node.name : EMPTY_STRING}</Title>
<img src={Close} alt="" onClick={()=>setModalFlag(false)}/>
        </div>
        <div className="view-junctions__block">
          {JunctionsFormLabels.map((field: LabelProps, key: React.Key) => {
            if (field.dataType === "textarea") {
              return (
                <React.Fragment key={key}>
                  <div className="label-grid">
                    <Label>{field.labelName}</Label>
                    <TextArea
                      value={
                        junctionData ? junctionData.node.address : EMPTY_STRING
                      }
                      rows={3}
                      disabled
                    />
                  </div>
                </React.Fragment>
              );
            }
            // else if (field.dataType === "icon") {
            //   return (
            //     <IconSelect
            //       onChange={(newValue) => {
            //         if (newValue) {
            //           setFormData({
            //             ...formData,
            //             icon: newValue.value as unknown as string,
            //           });
            //         } else {
            //           setFormData({
            //             ...formData,
            //             icon: "",
            //           });
            //         }
            //       }}
            //     />
            //   );
            // }
            else {
              return (
                <React.Fragment key={key}>
                  <div className="label-grid">
                    <Label>{field.labelName}</Label>
                 
                  <Input
                    value={
                      junctionData?.node[field.inputName as keyof Junction] ??
                      EMPTY_STRING
                    }
                   disabled
                  />
                   </div>
                </React.Fragment>
              );
            }
          })}
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default ParticuarJunctionDetails;
